import {
    GET_HDM_REPORT
} from './HdmPrintReport.actionsTypes';

export default function hdmReport(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_HDM_REPORT:
            return [
                ...action.payload || [],
            ];
        default:
            return newState;
        }
}